import React, { useState, useContext, useEffect, useRef } from "react";
import { FieldArray, Formik, Field } from "formik";
import { useLocation, useParams } from "react-router-dom";
import { Form, Card, Button } from "react-bootstrap";
import FilterSource from "./FilterSource";
import "../../../styles/containers/MapperLoadDefinitionFilter.scss";
import {
  FieldButtonGroup,
  FieldDropSide,
  DatePicker,
  SearchableList,
  FieldInput,
  ManageMapperLayout,
  LoaderWrapper,
  WarningModal,
  FormLeaveGuard,
} from "../../../components";
import { isEmpty, get, isNull } from "lodash";

import {
  manageMapperStore,
  setManageMapperToastInfo,
  setMapperPageLevelData,
  MANAGE_MAPPER_POST_API_ERROR,
  setFileUploadData,
  setMapperPostResponse,
} from "../../../contexts";
import {
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  manageMapperFormNames,
  usDateFormat,
  FLOW_TYPES,
  ROUTES,
  required,
  filterExpressionConverter,
} from "../../../utils";
import { useRouterParams } from "../../../abstracts";
import { onFilterSave, onPassthroughFilterSave } from "../../../services";

const stringOptions = [
  [
    "Is Not Null",
    "Is Null",
    "Between",
    "Is equal to",
    "Contains",
    "Starts With",
    "Ends With",
    "In",
    "Length Equal to",
    "Length Greater than",
    "Length Lesser than",
    "Length Greater than or equal to",
    "Length Lesser than or equal to",
    "Greater than",
    "Lesser than",
    "Greater than or equal to",
    "Lesser than or equal to",
  ],
];
const numOptions = [
  [
    "Is Not Null",
    "Is Null",
    "Between",
    "Is equal to",
    "Length Equal to",
    "Length Greater than",
    "Length Lesser than",
    "Length Greater than or equal to",
    "Length Lesser than or equal to",
    "Greater than",
    "Lesser than",
    "Greater than or equal to",
    "Lesser than or equal to",
  ],
];
const dateTypeOptions = [
  [
    "Is Not Null",
    "Is Null",
    "Between",
    "Is equal to",
    "Greater than",
    "Lesser than",
    "Greater than or equal to",
    "Lesser than or equal to",
  ],
];

const MapperFilterCondition = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageMapperStore);
  const location = useLocation();
  const { flow, profileId, mapType } = useRouterParams();
  const data = get(state, "api.data", []);

  const fileuploadData = get(state, "api.fileuploadData", []);

  const [applyFilter, setApplyFilter] = useState(false);
  const [optCont, setOptCont] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selopt, setSelopt] = useState(null);
  const isFilterApplied = get(data, "isFilterApplied", false);
  const [dataLoading, setDataLoading] = useState(false);
  const headerMapJson = get(data, "headerMapJson", []);

  //empty(no need)
  const fileUploadRow = get(
    fileuploadData,
    "mappingConfiguration.headerMapJson",
    []
  );

  const fieldHeadersJson = isEmpty(fileuploadData)
    ? headerMapJson
    : fileUploadRow;

  const filterObjectJson =
    !isEmpty(get(data, "filterObjectJson", {})) &&
    JSON.parse(get(data, "filterObjectJson", {}));

  const [FilterConditionFields, setFilterConditionFields] = useState([]);
  const isEdit = flow === FLOW_TYPES.EDIT;
  let i = 0;
  const [controlVar, setControlVar] = useState(true);
  const ref1 = useRef(null);

  const getFilterElements = (JSONList) => {
    setFilterConditionFields(
      JSONList.map((element, ind) => {
        return {
          order: element.order,
          field:
            element.fieldName[0] == "/"
              ? element.fieldName.substring(1)
              : element.fieldName,
          id: element.order,
          dataType: element.type,
          selected: false,
          filterSelect: false,
          firstchoice: "",
          value: element.datum,
          selectedFilter: "",
        };
      }).map((item, index) => {
        if (item.dataType === 1) {
          return {
            ...item,
            options: stringOptions,
            SimOpt: "",
          };
        } else if (item.dataType === 2) {
          return {
            ...item,
            options: numOptions,
            From: "",
            To: "",
            SimOpt: "",
          };
        } //selectOption - is for selecting the Operation and selectCustomOption is for selecting custom Operation.
        else if (item.dataType === 4) {
          return {
            ...item,
            options: dateTypeOptions,
            From: "",
            To: "",
            SimOpt: "",
          };
        } else {
          return item;
        }
      })
    );
  };

  useEffect(() => {
    !isEmpty(FilterConditionFields) &&
      FilterConditionFields.map((item) => {
        if (i == 0 && controlVar && item.selected) {
          i = i + 1;
          setControlVar(false);
          setSelopt(item.id);
        }
      });
  });

  useEffect(() => {
    if (!isEmpty(get(state, formName, []))) {
      setApplyFilter(get(state, formName, []).isFilterApplied);
    } else {
      setApplyFilter(isFilterApplied);
    }
  }, [isFilterApplied]);

  //If filter is already applied

  useEffect(() => {
    if (!isEmpty(get(state, formName, [])) && !isEmpty(FilterConditionFields)) {
      const filterObjectJsonFromState = get(state, formName, [])
        .filterObjectJson
        ? JSON.parse(get(state, formName, []).filterObjectJson)
        : JSON.parse(get(state, "api.data", []).filterObjectJson);
      setFilterConditionFields(filterObjectJsonFromState);
    } else if (isEmpty(FilterConditionFields)) {
      if (isFilterApplied && mapType != 3 && filterObjectJson && isEdit) {
        setFilterConditionFields(filterObjectJson);
      } else if (
        !isEdit &&
        !isEmpty(fieldHeadersJson) &&
        isEmpty(headerMapJson)
      ) {
        getFilterElements(JSON.parse(fieldHeadersJson));
      } else if (isEmpty(filterObjectJson) && !isEmpty(headerMapJson)) {
        getFilterElements(JSON.parse(fieldHeadersJson));
      } else if (
        isEmpty(filterObjectJson) &&
        !isEmpty(headerMapJson) &&
        !isEmpty(fileUploadRow)
      ) {
        getFilterElements(JSON.parse(fieldHeadersJson));
      } else if (!isEmpty(filterObjectJson)) {
        setFilterConditionFields(filterObjectJson);
      }
    } else if (!isEmpty(FilterConditionFields)) {
      console.log("setfilterdData", fieldHeadersJson);
      if (isFilterApplied && filterObjectJson && isEdit) {
        setFilterConditionFields(filterObjectJson);
      } else if (
        !isEdit &&
        !isEmpty(fieldHeadersJson) &&
        isEmpty(headerMapJson)
      ) {
        getFilterElements(JSON.parse(fieldHeadersJson));
      } else if (isEmpty(filterObjectJson) && !isEmpty(headerMapJson)) {
        getFilterElements(JSON.parse(fieldHeadersJson));
      } else if (
        isEmpty(filterObjectJson) &&
        !isEmpty(headerMapJson) &&
        !isEmpty(fileUploadRow)
      ) {
        getFilterElements(JSON.parse(fieldHeadersJson));
      } else if (!isEmpty(filterObjectJson)) {
        setFilterConditionFields(filterObjectJson);
      }
    } else {
      getFilterElements(JSON.parse(fieldHeadersJson));
    }
  }, [isEdit, state, fieldHeadersJson]);

  //If filter is not already applied

  const toOptionValuesFromMapper = (obj) => {
    return Object.keys(obj).map((key) => ({
      label: obj[key],
      value: !isNaN(key) ? parseInt(key, 10) : key,
    }));
  };
  const formName = manageMapperFormNames.FILTER;

  // const toSubmit = (values) => {
  //   setDataLoading(true);
  //   const { history } = props;
  //   dispatch(
  //     setMapperPageLevelData({
  //       formName: formName,
  //       fieldData: {
  //         isFilterApplied: applyFilter,
  //         filterObjectJson: JSON.stringify(values),
  //       },
  //       format: data.format
  //         ? data.format
  //         : fileuploadData.mappingConfiguration.format,
  //     })
  //   );
  //   {
  //     mapType == 3 ? onPassthroughFilterSave({
  //       ...data,
  //       isFilterApplied: applyFilter,
  //       filterObjectJson: JSON.stringify(values),
  //     })
  //       .then((res) => {
  //         if (!isEmpty(res)) {
  //           setDataLoading(false);
  //           dispatch(
  //             setFileUploadData({
  //               mappingConfiguration: res,
  //             })
  //           );
  //           dispatch(
  //             setManageMapperToastInfo({
  //               showToast: true,
  //               toastMessage: "Data saved successfully",
  //             })
  //           );
  //           isEdit
  //             ? history.push(
  //               getPathWithParam({
  //                 path: MANAGE_MAPPER_ROUTES.AGGREGATE,
  //                 pathParam: [FLOW_TYPES.EDIT, mapType, profileId],
  //               })
  //             )
  //             : history.push(
  //               `${MANAGE_MAPPER_ROUTES.AGGREGATE}/${mapType}/${profileId}`
  //             );
  //         } else {
  //           dispatch({
  //             type: MANAGE_MAPPER_POST_API_ERROR,
  //             payload: "Something went wrong! please try again.",
  //           });
  //           setDataLoading(false);
  //         }
  //       })
  //       .catch((err) => {
  //         setDataLoading(false);
  //         dispatch({
  //           type: MANAGE_MAPPER_POST_API_ERROR,
  //           payload: "Something went wrong! please try again.",
  //         });
  //       }) :
  //     onFilterSave({
  //       ...data,
  //       isFilterApplied: applyFilter,
  //       filterObjectJson: JSON.stringify(values),
  //     })
  //       .then((res) => {
  //         if (!isEmpty(res)) {
  //           setDataLoading(false);
  //           dispatch(
  //             setFileUploadData({
  //               mappingConfiguration: res,
  //             })
  //           );
  //           dispatch(
  //             setManageMapperToastInfo({
  //               showToast: true,
  //               toastMessage: "Data saved successfully",
  //             })
  //           );
  //           isEdit
  //             ? history.push(
  //               getPathWithParam({
  //                 path: MANAGE_MAPPER_ROUTES.AGGREGATE,
  //                 pathParam: [FLOW_TYPES.EDIT, mapType, profileId],
  //               })
  //             )
  //             : history.push(
  //               `${MANAGE_MAPPER_ROUTES.AGGREGATE}/${mapType}/${profileId}`
  //             );
  //         } else {
  //           dispatch({
  //             type: MANAGE_MAPPER_POST_API_ERROR,
  //             payload: "Something went wrong! please try again.",
  //           });
  //           setDataLoading(false);
  //         }
  //       })
  //       .catch((err) => {
  //         setDataLoading(false);
  //         dispatch({
  //           type: MANAGE_MAPPER_POST_API_ERROR,
  //           payload: "Something went wrong! please try again.",
  //         });
  //       })
  //   }
  // };

  const toSubmit = (values) => {
    setDataLoading(true);
    const { history } = props;
    let filterOption = FilterConditionFields.filter((itm) => itm.selected);
    let saveData =
      filterOption &&
      filterOption.map((_) => {
        return {
          fieldName: _.propertyName,
          expression: filterExpressionConverter(_),
        };
      });
    const commonData = {
      ...data,
      isFilterApplied: applyFilter,
      filterObjectJson:
        mapType === 3
          ? JSON.stringify(applyFilter ? saveData : [])
          : JSON.stringify(values),
    };
    if (mapType == 3) {
      onPassthroughFilterSave(commonData)
        .then((res) => {
          if (!isEmpty(res)) {
            setDataLoading(false);
            // dispatch(setFileUploadData({ mappingConfiguration: res }));
            // dispatch(
            //   setManageMapperToastInfo({
            //     showToast: true,
            //     toastMessage: "Data saved successfully",
            //   })
            // );
            dispatch(setFileUploadData({ mappingConfiguration: res }));
            dispatch(
              setManageMapperToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
            const path = isEdit
              ? getPathWithParam({
                  path: MANAGE_MAPPER_ROUTES.AGGREGATE,
                  pathParam: [FLOW_TYPES.EDIT, mapType, profileId],
                })
              : `${MANAGE_MAPPER_ROUTES.AGGREGATE}/${mapType}/${profileId}`;

            history.push(path);
          } else {
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! Please try again.",
            });
            setDataLoading(false);
          }
        })
        .catch((err) => {
          setDataLoading(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! Please try again.",
          });
        });
    } else {
      onFilterSave(commonData)
        .then((res) => {
          if (!isEmpty(res)) {
            setDataLoading(false);
            dispatch(setFileUploadData({ mappingConfiguration: res }));
            dispatch(
              setManageMapperToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
            const path = isEdit
              ? getPathWithParam({
                  path: MANAGE_MAPPER_ROUTES.AGGREGATE,
                  pathParam: [FLOW_TYPES.EDIT, mapType, profileId],
                })
              : `${MANAGE_MAPPER_ROUTES.AGGREGATE}/${mapType}/${profileId}`;

            history.push(path);
          } else {
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! Please try again.",
            });
            setDataLoading(false);
          }
        })
        .catch((err) => {
          setDataLoading(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! Please try again.",
          });
        });
    }
  };

  const navigateToMapperHomePage = () => {
    history.push(
      getPathWithParam({
        path: `${ROUTES.MAPPER_HOME}`,
      })
    );
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setModalVisible(true);
      },
    },

    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];

  const yesNoOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];
  return (
    <Formik
      initialValues={FilterConditionFields}
      onSubmit={toSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
      innerRef={ref1}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          validateOnChange,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          dirty,
          touched,
          ...rest
        } = formProps;
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };

        return (
          <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
            <ManageMapperLayout buttons={buttons} layoutHeader="Filter">
              <LoaderWrapper isLoading={dataLoading}>
                <FormLeaveGuard
                  showModal={modalVisible}
                  handleConfirmClick={() => navigateToMapperHomePage()}
                  handleCancelClick={() => setModalVisible(false)}
                />

                <div>
                  <div
                    style={{
                      display: "block",
                      // font: "Poppins",
                      fontSize: "18px",
                      fontWeight: "500",
                      alignItems: "center",
                      paddingBottom: "0",
                    }}
                  >
                    <div
                      style={{
                        paddingBottom: "0.5rem",
                        color: "#494F5A",
                        fontSize: "18px",
                        fontWeight: "550",
                      }}
                    >
                      Apply filter
                    </div>
                    <div style={{ display: "flex" }}>
                      <Field
                        isRequired
                        name="Apply filter"
                        size="md"
                        className="bg-transparent p-0"
                        options={yesNoOptions}
                        selectedValue={applyFilter}
                        onChange={(value) => {
                          setApplyFilter(value);
                        }}
                        component={FieldButtonGroup}
                      />
                    </div>
                  </div>
                </div>

                {applyFilter && !isEmpty(FilterConditionFields) ? (
                  <div style={{ display: "flex", overflowX: "scroll" }}>
                    <FilterSource
                      fields={FilterConditionFields}
                      setfields={setFilterConditionFields}
                      fileName={data.fileName}
                    />
                    <div className="FilterConditionContainer">
                      <div className="FilterConditionTitleText">
                        Selected filter condition
                      </div>
                      <div>
                        <FieldArray name="info">
                          {() => (
                            <div
                              style={{
                                border: "1px solid #E5E5E5",
                                borderRadius: "5px",
                                // border: "2px solid yellow",
                                width: "42rem",
                                height: "28rem",
                                display: "flex",
                              }}
                            >
                              <div className="FilterList">
                                {FilterConditionFields.map((item, index) => {
                                  return item.selected ? (
                                    <>
                                      <Card
                                        className={
                                          selopt == item.id
                                            ? "FTargetCard-selected"
                                            : "FTargetCard-normal"
                                        }
                                        id={item.id}
                                        onClick={() => {
                                          setOptCont(true);
                                          let newfields = [
                                            ...FilterConditionFields,
                                          ];
                                          newfields[index][
                                            "filterSelect"
                                          ] = true;
                                          setFilterConditionFields(newfields);
                                          setSelopt(item.id);
                                        }}
                                      >
                                        <div className="FTitle">
                                          {" "}
                                          {item.field}
                                        </div>
                                      </Card>
                                    </>
                                  ) : (
                                    <> </>
                                  );
                                })}
                              </div>
                              <div className="OptionContainer">
                                {FilterConditionFields.map((item, index) => {
                                  return item.selected ? (
                                    <>
                                      {item.filterSelect && selopt == item.id && (
                                        <>
                                          <div className="OptTitle">
                                            Filter Options
                                          </div>
                                          <div className="ConTitle">
                                            Condition
                                          </div>
                                          <div
                                            key={item.id}
                                            style={{
                                              width: "20rem",
                                              fontSize: "14px",
                                              // font: "Poppins",
                                              fontWeight: "400",
                                              paddingBottom: "1rem",
                                            }}
                                          >
                                            <div className="dropdown-alignment">
                                              <Field
                                                name={`${index}.SimOpt`}
                                                value={values[index]["SimOpt"]}
                                                validate={required}
                                                options={toOptionValuesFromMapper(
                                                  item.options[0]
                                                )}
                                                isRequired
                                                direction={"bottom"}
                                                popupContent={
                                                  <SearchableList
                                                    label="Profile Type"
                                                    isNotTypeAhead
                                                    options={toOptionValuesFromMapper(
                                                      item.options[0]
                                                    )}
                                                    onSelect={(value) =>
                                                      setFieldValue(
                                                        `${index}.SimOpt`,
                                                        value
                                                      )
                                                    }
                                                    selectedValue={
                                                      values[index]["SimOpt"]
                                                    }
                                                  />
                                                }
                                                component={FieldDropSide}
                                              />
                                            </div>
                                            {!(
                                              values[index]["SimOpt"] == 0 ||
                                              values[index]["SimOpt"] == 1 ||
                                              values[index]["SimOpt"] == ""
                                            ) ? (
                                              item.dataType === 1 ? (
                                                <div>
                                                  <>
                                                    <div className="ConTitle">
                                                      Input
                                                    </div>
                                                  </>
                                                  <Field
                                                    name={`${index}.selectedFilter`}
                                                    values={`values[${index}].selectedFilter`}
                                                    component={FieldInput}
                                                    onChange={handleChange}
                                                    isRequired
                                                    validate={required}
                                                  />
                                                  <div>
                                                    {/* {values[index].selectedFilter} */}
                                                  </div>
                                                </div>
                                              ) : !(item.dataType === 4) ? (
                                                !(
                                                  values[index]["SimOpt"] == 2
                                                ) ? (
                                                  <div>
                                                    <>
                                                      <div className="ConTitle">
                                                        Input
                                                      </div>
                                                    </>
                                                    <Field
                                                      name={`${index}.selectedFilter`}
                                                      values={`values[${index}].selectedFilter`}
                                                      component={FieldInput}
                                                      onChange={handleChange}
                                                      isRequired
                                                      validate={required}
                                                    />
                                                    <div>
                                                      {/* {values[index].selectedFilter} */}
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div>
                                                    <>
                                                      <div className="ConTitle">
                                                        From
                                                      </div>
                                                    </>
                                                    <Field
                                                      name={`${index}.From`}
                                                      values={`values[${index}].From`}
                                                      component={FieldInput}
                                                      onChange={handleChange}
                                                      isRequired
                                                      validate={required}
                                                    />
                                                    <div className="ConTitle">
                                                      To
                                                    </div>
                                                    <Field
                                                      name={`${index}.To`}
                                                      values={`values[${index}].To`}
                                                      component={FieldInput}
                                                      onChange={handleChange}
                                                      isRequired
                                                      validate={required}
                                                    />
                                                  </div>
                                                )
                                              ) : !(
                                                  values[index]["SimOpt"] == 2
                                                ) ? (
                                                <div>
                                                  <div className="ConTitle">
                                                    Select date
                                                  </div>
                                                  <Field
                                                    name={`${index}.selectedFilter`}
                                                    isRequired
                                                    validate={required}
                                                    size="sm"
                                                    value={usDateFormat(
                                                      item.selectedFilter
                                                    )}
                                                    onClear={() => {
                                                      setFieldValue(
                                                        `${index}.selectedFilter`,
                                                        ""
                                                      );
                                                      item.selectedFilter = "";
                                                    }}
                                                    isDatePicker
                                                    popupContent={
                                                      <DatePicker
                                                        onDayClick={(value) => {
                                                          onDaySelected(
                                                            `${index}.selectedFilter`,
                                                            value
                                                          );
                                                          item.selectedFilter = value;
                                                          let newfields = [
                                                            ...FilterConditionFields,
                                                          ];
                                                          newfields[index][
                                                            "selectedFilter"
                                                          ] = usDateFormat(
                                                            value
                                                          );
                                                          setFilterConditionFields(
                                                            newfields
                                                          );
                                                        }}
                                                        value={usDateFormat(
                                                          values[
                                                            `${index}.selectedFilter`
                                                          ]
                                                        )}
                                                      />
                                                    }
                                                    component={FieldDropSide}
                                                  />
                                                </div>
                                              ) : (
                                                <div>
                                                  <div className="ConTitle">
                                                    From
                                                  </div>
                                                  <Field
                                                    name={`${index}.From`}
                                                    isRequired
                                                    validate={required}
                                                    size="sm"
                                                    value={usDateFormat(
                                                      item.From
                                                    )}
                                                    onClear={() => {
                                                      setFieldValue(
                                                        `${index}.From`,
                                                        ""
                                                      );
                                                      item.From = "";
                                                    }}
                                                    isDatePicker
                                                    popupContent={
                                                      <DatePicker
                                                        onDayClick={(value) => {
                                                          onDaySelected(
                                                            `${index}.From`,
                                                            value
                                                          );
                                                          item.From = value;
                                                          let newfields = [
                                                            ...FilterConditionFields,
                                                          ];
                                                          newfields[index][
                                                            "From"
                                                          ] = usDateFormat(
                                                            value
                                                          );
                                                          setFilterConditionFields(
                                                            newfields
                                                          );
                                                        }}
                                                        value={usDateFormat(
                                                          values[
                                                            `${index}.From`
                                                          ]
                                                        )}
                                                      />
                                                    }
                                                    component={FieldDropSide}
                                                  />
                                                  <div className="ConTitle">
                                                    To
                                                  </div>
                                                  <Field
                                                    name={`${index}.To`}
                                                    isRequired
                                                    size="sm"
                                                    validate={required}
                                                    value={usDateFormat(
                                                      item.To
                                                    )}
                                                    onClear={() => {
                                                      setFieldValue(
                                                        `${index}.To`,
                                                        ""
                                                      );
                                                      item.To = "";
                                                    }}
                                                    isDatePicker
                                                    popupContent={
                                                      <DatePicker
                                                        onDayClick={(value) => {
                                                          onDaySelected(
                                                            `${index}.To`,
                                                            value
                                                          );
                                                          item.To = value;
                                                          let newfields = [
                                                            ...FilterConditionFields,
                                                          ];
                                                          newfields[index][
                                                            "To"
                                                          ] = usDateFormat(
                                                            value
                                                          );
                                                          setFilterConditionFields(
                                                            newfields
                                                          );
                                                        }}
                                                        value={usDateFormat(
                                                          values[`${index}.To`]
                                                        )}
                                                      />
                                                    }
                                                    component={FieldDropSide}
                                                  />
                                                </div>
                                              )
                                            ) : (
                                              <> </>
                                            )}
                                          </div>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <> </>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </FieldArray>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="FilterUnavailable"> Filter not applied</div>
                  </>
                )}
                {/* <pre>{JSON.stringify(FilterConditionFields, null, 2)}</pre> */}
              </LoaderWrapper>
            </ManageMapperLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default MapperFilterCondition;
